import { Link, useLocation } from 'react-router-dom';
import PageShell from '@/components/feature/PageShell';
import Seo from '@/components/base/Seo';
import { categories } from '@/mocks/categories';

export default function NotFound() {
  const location = useLocation();

  return (
    <PageShell>
      <Seo
        title="页面未找到 - 职镜观察"
        description="你访问的页面不存在或地址已调整，可以返回首页，或从主题分类中继续浏览职场观察内容。"
      />
      <div className="mx-auto flex max-w-content flex-col items-center px-4 py-20 text-center md:px-6 md:py-28">
        <span className="font-heading text-[5rem] font-black leading-none text-background-300 md:text-[8rem]">
          404
        </span>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这个页面没有找到
        </h1>
        <p className="mt-3 max-w-lg text-sm leading-relaxed text-foreground-600">
          你访问的地址不存在，可能是链接已经调整。
          <span className="mt-1 block font-label text-xs text-foreground-400">{location.pathname}</span>
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-600 px-5 py-3 font-label text-sm text-background-50 transition-colors hover:bg-primary-700"
          >
            返回首页
          </Link>
          <Link
            to="/insight"
            className="whitespace-nowrap rounded-md border border-background-300 px-5 py-3 font-label text-sm text-foreground-800 transition-colors hover:border-primary-400"
          >
            浏览内幕观察
          </Link>
        </div>
        <div className="mt-10 flex flex-wrap justify-center gap-2">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="rounded-full border border-background-300 px-3.5 py-1.5 font-label text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </PageShell>
  );
}